<template>
  <v-card flat>
    <v-card-text class="text-xs-center">

      <v-flex xs6 offset-xs3>
        <v-text-field v-model="paypalAmount"
                      class="mb-5"
                      name="paypalAmount"
                      :label="$t('attrs.amount')"
                      v-validate="`required|min_value:${ minValidAmount }`"
                      :error-messages="errors.collect('paypalAmount')"
                      data-vv-name="paypalAmount"
                      :data-vv-as="$t('attrs.amount')"
                      :hint="(paypalAmount > 0) ? $t('paypalHint', {amountPercent: amountPercent}) : ''"
                      persistent-hint
                      required
                      ></v-text-field>
        <div id="paypal-button-container" :style="`pointer-events: ${ buttonPointerEvent }`"></div>
      </v-flex>

    </v-card-text>
  </v-card>
</template>

<script>
import Setting from '@/client/setting'
export default {
  name: 'AddFundsPayPalComp',

  props: {},

  data () {
    return {
      paypalAmount: 0,
      amountPercent: '',
      minValidAmount: 0,
      buttonPointerEvent: 'none'
    }
  },

  components: {
  },

  computed: {
    paypalEnv () {
      if (process.env.NODE_ENV === 'production') { return 'production' }
      return 'sandbox'
    }
  },

  methods: {
    configPaypal () {
      const auth = this.$auth.accessToken
      const self = this
      window.paypal.Button.render({
        env: this.paypalEnv, // sandbox | production

        // Show the buyer a 'Pay Now' button in the checkout flow
        commit: true,

        // payment() is called when the button is clicked
        payment () {
          // Set up a url on your server to create the payment
          const CREATE_URL = `${process.env.VUE_APP_API_URL}/paypal/checkout`

          // Make a call to your server to set up the payment
          return window.paypal.request.post(
            CREATE_URL,
            {
              amount: self.paypalAmount
            },
            {
              headers: {
                'X-TENANT-ID': process.env.VUE_APP_TENANT_ID,
                authorization: auth
              }
            }).then(res => res.paymentID)
        },

        // onAuthorize() is called when the buyer approves the payment
        onAuthorize (data) {
          // Set up a url on your server to execute the payment
          const EXECUTE_URL = `${process.env.VUE_APP_API_URL}/paypal/execute`

          // Set up the data you need to pass to your server
          const params = {
            payment_id: data.paymentID,
            payer_id: data.payerID
          }

          // Make a call to your server to execute the payment
          return window.paypal.request.post(
            EXECUTE_URL,
            params,
            {
              headers: {
                'X-TENANT-ID': process.env.VUE_APP_TENANT_ID,
                authorization: auth
              }
            }).then(() => {
              self.$auth.getCurrentUser()
              self.goTo('myTransactions')
            })
        }
      }, '#paypal-button-container')
    }
  },

  watch: {
    paypalAmount () {
      if (this.paypalAmount > 0 && this.paypalAmount <= 50000) this.amountPercent = '4.58% + $4.64'
      if (this.paypalAmount > 50000 && this.paypalAmount <= 250000) this.amountPercent = '4.23% + $4.64'
      if (this.paypalAmount > 250000 && this.paypalAmount <= 500000) this.amountPercent = '4% + $4.64'
      if (this.paypalAmount > 500000 && this.paypalAmount <= 1000000) this.amountPercent = '3.65% + $4.64'
      if (this.paypalAmount > 1000000) this.amountPercent = '3.42% + $4.64'

      this.buttonPointerEvent = (parseFloat(this.paypalAmount) >= parseFloat(this.minValidAmount)) ? 'auto' : 'none'
    }
  },

  async mounted () {
    this.configPaypal()

    this.settings = await Setting.all()
    this.minValidAmount = this.settings.find(o => o.key === 'paypal_min_amount').value || 0
  }
}
</script>
